"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configToProtoFields = exports.configToProto = exports.protoToB64 = void 0;
var metrics_engine_1 = require("@tableau/metrics-engine");
var data_values_pb_1 = require("@tableau/metrics-models-typescript-interface/lib/tableau/metrics/models/data_values_pb");
var date_granularity_pb_1 = require("@tableau/metrics-models-typescript-interface/lib/tableau/metrics/models/date_granularity_pb");
var date_window_pb_1 = require("@tableau/metrics-models-typescript-interface/lib/tableau/metrics/models/date_window_pb");
var duration_pb_1 = require("@tableau/metrics-models-typescript-interface/lib/tableau/metrics/models/duration_pb");
var metric_configuration_pb_1 = require("@tableau/metrics-models-typescript-interface/lib/tableau/metrics/models/metric_configuration_pb");
var threshold_pb_1 = require("@tableau/metrics-models-typescript-interface/lib/tableau/metrics/models/threshold_pb");
var google_protobuf_1 = require("google-protobuf");
function protoToB64(proto) {
    return google_protobuf_1.Message.bytesAsB64(proto.serializeBinary());
}
exports.protoToB64 = protoToB64;
/**
 *
 * @param config the `MetricConfig` to convert
 * @returns a `MetricConfiguration` protobuf
 */
function configToProto(config) {
    var fields = configToProtoFields(config);
    var configProto = new metric_configuration_pb_1.MetricConfiguration();
    configProto.setThresholdsList(fields.thresholdsList);
    configProto.setDateWindowList(fields.dateWindowList);
    return configProto;
}
exports.configToProto = configToProto;
/**
 *
 * @param config the `MetricConfig` to convert
 * @returns a `ConfigurationFields` matching the given config.
 */
function configToProtoFields(_a) {
    var comparison = _a.comparison, status = _a.status, window = _a.window;
    var thresholdsList = makeThresholdsList({ selectedComparison: comparison, selectedStatus: status });
    var dateWindowList = makeDateWindowList(window);
    return { thresholdsList: thresholdsList, dateWindowList: dateWindowList };
}
exports.configToProtoFields = configToProtoFields;
function makeDateWindowList(selectedDateWindow) {
    var windowList = [];
    if (selectedDateWindow !== null) {
        windowList = [dateWindowToProtobuf(selectedDateWindow)];
    }
    return windowList;
}
function makeThresholdsList(_a) {
    var _b;
    var selectedComparison = _a.selectedComparison, selectedStatus = _a.selectedStatus;
    if (selectedComparison === null) {
        return [];
    }
    if ((0, metrics_engine_1.isStaticComparison)(selectedComparison)) {
        var thresholdValue = new threshold_pb_1.StaticValueThresholdValue();
        thresholdValue.setDoubleValue(selectedComparison.value);
        var thresholdType = new threshold_pb_1.StaticValueThresholdType();
        thresholdType.setValue(thresholdValue);
        var status_1 = statusToProto(selectedStatus);
        if (status_1 !== undefined) {
            thresholdType.setStatus(status_1);
        }
        var staticThreshold = new threshold_pb_1.Threshold();
        staticThreshold.setTypeStaticValue(thresholdType);
        return [staticThreshold];
    }
    if ((0, metrics_engine_1.isHistoricalOrMarkBasedComparison)(selectedComparison)) {
        var thresholdValue = new threshold_pb_1.NumberOfPeriodsThresholdType();
        thresholdValue.setShowComparisonLine((0, metrics_engine_1.shouldShowComparisonLine)(selectedComparison));
        var duration = new duration_pb_1.Duration();
        var numberOfUnits = (0, metrics_engine_1.isHistoricalComparisonSpec)(selectedComparison)
            ? (_b = selectedComparison.numberOfPeriods) !== null && _b !== void 0 ? _b : 1
            : selectedComparison.numberOfMarks;
        duration.setNumberOfUnits(numberOfUnits);
        var dateTrunc = (0, metrics_engine_1.isHistoricalComparisonSpec)(selectedComparison)
            ? selectedComparison.comparisonPeriod
            : metrics_engine_1.DateTrunc.UNKNOWN;
        duration.setDateGranularity(dateTruncToProtobuf(dateTrunc));
        thresholdValue.setDuration(duration);
        var numberOfPeriodsThreshold = new threshold_pb_1.Threshold();
        numberOfPeriodsThreshold.setTypeNumberOfPeriods(thresholdValue);
        return [numberOfPeriodsThreshold];
    }
    return [];
}
function statusToProto(selectedStatus) {
    var status = undefined;
    if (selectedStatus.above !== null || selectedStatus.equal !== null || selectedStatus.below !== null) {
        status = new threshold_pb_1.SimpleStatus();
        status.setAbove(thresholdStatusToProtobuf(unspecifiedStatusIfNull(selectedStatus.above)));
        status.setEqual(thresholdStatusToProtobuf(unspecifiedStatusIfNull(selectedStatus.equal)));
        status.setBelow(thresholdStatusToProtobuf(unspecifiedStatusIfNull(selectedStatus.below)));
    }
    return status;
}
var thresholdStatusToProtobuf = function (thresholdStatus) {
    switch (thresholdStatus) {
        case metrics_engine_1.ThresholdStatus.BAD:
            return threshold_pb_1.ThresholdStatus.THRESHOLD_STATUS_BAD;
        case metrics_engine_1.ThresholdStatus.GOOD:
            return threshold_pb_1.ThresholdStatus.THRESHOLD_STATUS_GOOD;
        case metrics_engine_1.ThresholdStatus.NEUTRAL:
            return threshold_pb_1.ThresholdStatus.THRESHOLD_STATUS_NEUTRAL;
        case metrics_engine_1.ThresholdStatus.UNKNOWN:
        default:
            return threshold_pb_1.ThresholdStatus.THRESHOLD_STATUS_UNSPECIFIED;
    }
};
var unspecifiedStatusIfNull = function (thresholdStatus) {
    return thresholdStatus === null ? metrics_engine_1.ThresholdStatus.UNKNOWN : thresholdStatus;
};
var dateTruncToProtobuf = function (dateTrunc) {
    switch (dateTrunc) {
        case metrics_engine_1.DateTrunc.SECOND: {
            return date_granularity_pb_1.DateGranularity.DATE_GRANULARITY_SECOND;
        }
        case metrics_engine_1.DateTrunc.MINUTE: {
            return date_granularity_pb_1.DateGranularity.DATE_GRANULARITY_MINUTE;
        }
        case metrics_engine_1.DateTrunc.HOUR: {
            return date_granularity_pb_1.DateGranularity.DATE_GRANULARITY_HOUR;
        }
        case metrics_engine_1.DateTrunc.DAY: {
            return date_granularity_pb_1.DateGranularity.DATE_GRANULARITY_DAY;
        }
        case metrics_engine_1.DateTrunc.WEEK: {
            return date_granularity_pb_1.DateGranularity.DATE_GRANULARITY_WEEK;
        }
        case metrics_engine_1.DateTrunc.MONTH: {
            return date_granularity_pb_1.DateGranularity.DATE_GRANULARITY_MONTH;
        }
        case metrics_engine_1.DateTrunc.QUARTER: {
            return date_granularity_pb_1.DateGranularity.DATE_GRANULARITY_QUARTER;
        }
        case metrics_engine_1.DateTrunc.YEAR: {
            return date_granularity_pb_1.DateGranularity.DATE_GRANULARITY_YEAR;
        }
        case metrics_engine_1.DateTrunc.UNKNOWN:
        case metrics_engine_1.DateTrunc.NONE:
        case undefined:
        default: {
            return date_granularity_pb_1.DateGranularity.DATE_GRANULARITY_UNKNOWN;
        }
    }
};
var dateWindowToProtobuf = function (dateWindow) {
    var dateWindowProtobuf = new date_window_pb_1.DateWindow();
    switch (dateWindow.type) {
        case metrics_engine_1.DateWindowTypes.LAST_N: {
            var lastNWindow = dateWindow;
            var latestWindowProtobuf = new date_window_pb_1.LatestDataWindowType();
            var duration = new duration_pb_1.Duration();
            duration.setNumberOfUnits(lastNWindow.n);
            duration.setDateGranularity(dateTruncToProtobuf(metrics_engine_1.DateTrunc.UNKNOWN));
            latestWindowProtobuf.setDuration(duration);
            dateWindowProtobuf.setTypeLatestDataWindow(latestWindowProtobuf);
            break;
        }
        case metrics_engine_1.DateWindowTypes.LATEST_DATA: {
            var latestWindow = dateWindow;
            var latestWindowProtobuf = new date_window_pb_1.LatestDataWindowType();
            var duration = new duration_pb_1.Duration();
            duration.setNumberOfUnits(latestWindow.duration.numberOfUnits);
            duration.setDateGranularity(dateTruncToProtobuf(latestWindow.duration.unit));
            latestWindowProtobuf.setDuration(duration);
            dateWindowProtobuf.setTypeLatestDataWindow(latestWindowProtobuf);
            break;
        }
        case metrics_engine_1.DateWindowTypes.DEFINED_START: {
            var definedStart = dateWindow;
            var definedStartProtobuf = new date_window_pb_1.DefinedStartWindowType();
            var dateTime = new data_values_pb_1.DateTime();
            dateTime.setDateTime((0, metrics_engine_1.dateISOStringWithoutTimezone)(definedStart.startDate));
            definedStartProtobuf.setStartDate(dateTime);
            dateWindowProtobuf.setTypeDefinedStartWindow(definedStartProtobuf);
            break;
        }
        case metrics_engine_1.DateWindowTypes.SPECIAL: {
            dateWindowProtobuf.setTypeAllTimeWindow(new date_window_pb_1.AllTimeWindowType());
            break;
        }
        case metrics_engine_1.DateWindowTypes.CUSTOM:
        case undefined:
        default:
    }
    return dateWindowProtobuf;
};
//# sourceMappingURL=convertToProto.js.map